import type { OperationVariables, QueryResult } from '@apollo/client';
import type { DocumentNode } from 'graphql';
import { useManagedQuery } from './useManagedQuery';

export function useNovaQuery<
    TData = any,
    TVariables extends OperationVariables = OperationVariables
>(
    query: DocumentNode,
    variables?: {
        [name: string]: unknown;
    },
    options?: {}
): QueryResult<TData, TVariables> {
    const wrappedOptions: OperationVariables = {
        variables,
        returnPartialData: true,
        fetchPolicy: 'cache-only',
        ...options,
    };
    return useManagedQuery(query, wrappedOptions);
}
